module.exports = __webpack_public_path__ + "img/pin-grey.4e85248a.svg";